import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withModifiers as _withModifiers, vShow as _vShow, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  id: "searchbox",
  class: "card"
}
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "row mb-3 gx-3 align-items-center" }
const _hoisted_4 = { class: "col-auto" }
const _hoisted_5 = { class: "input-group" }
const _hoisted_6 = { class: "col-auto" }
const _hoisted_7 = { class: "input-group" }
const _hoisted_8 = { class: "row mb-3 gx-3 align-items-center" }
const _hoisted_9 = { class: "col-auto" }
const _hoisted_10 = { class: "input-group" }
const _hoisted_11 = ["value"]
const _hoisted_12 = {
  key: 0,
  style: {"margin-left":"3em"}
}
const _hoisted_13 = {
  key: 1,
  class: "table table-sm table-hover"
}
const _hoisted_14 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_datepicker = _resolveComponent("datepicker")!
  const _component_loading_spinner = _resolveComponent("loading-spinner")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "card-header row" }, "Filter", -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", {
          onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.get_events && _ctx.get_events(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[4] || (_cache[4] = _createElementVNode("div", { class: "input-group-text" }, "From", -1)),
                _createVNode(_component_datepicker, {
                  modelValue: _ctx.pickerStartDate,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pickerStartDate) = $event)),
                  typeable: "",
                  inputFormat: _ctx.dateFormat,
                  class: "input-sm form-control",
                  minimumView: "time",
                  onfocusout: _ctx.push_end_date()
                }, null, 8, ["modelValue", "inputFormat", "onfocusout"])
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[5] || (_cache[5] = _createElementVNode("div", { class: "input-group-text" }, "To", -1)),
                _createVNode(_component_datepicker, {
                  modelValue: _ctx.pickerEndDate,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.pickerEndDate) = $event)),
                  "lower-limit": _ctx.pickerStartDate,
                  typeable: "",
                  inputFormat: _ctx.dateFormat,
                  class: "input-sm form-control",
                  minimumView: "time"
                }, null, 8, ["modelValue", "lower-limit", "inputFormat"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "input-group-text" }, "Origin", -1)),
                _withDirectives(_createElementVNode("select", {
                  class: "input-sm form-control",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.origin) = $event))
                }, [
                  _cache[6] || (_cache[6] = _createElementVNode("option", {
                    value: {},
                    selected: ""
                  }, "-- All --", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.origins, (origin) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: origin,
                      key: origin
                    }, _toDisplayString(origin.Site) + " / " + _toDisplayString(origin.Aggregator), 9, _hoisted_11))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.filters.origin]
                ])
              ])
            ])
          ]),
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "form-row" }, [
            _createElementVNode("button", {
              type: "submit",
              class: "btn btn-primary"
            }, "Update Results")
          ], -1))
        ], 32)
      ])
    ]),
    _withDirectives(_createVNode(_component_loading_spinner, null, null, 512), [
      [_vShow, _ctx.isLoading]
    ]),
    (_ctx.events.length == 0 && !_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("p", _hoisted_12, "No events match these filters."))
      : _createCommentVNode("", true),
    (_ctx.events.length > 0)
      ? (_openBlock(), _createElementBlock("table", _hoisted_13, [
          _cache[10] || (_cache[10] = _createElementVNode("thead", { class: "thead" }, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", { scope: "col" }, "Time"),
              _createElementVNode("th", { scope: "col" }, "Origin"),
              _createElementVNode("th", { scope: "col" }, "Summary"),
              _createElementVNode("th", { scope: "col" }, "Details")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.events, (event) => {
              return (_openBlock(), _createElementBlock("tr", { key: event }, [
                _createElementVNode("td", null, _toDisplayString(_ctx.formatTime(event.Time)), 1),
                _createElementVNode("td", null, _toDisplayString(event.OriginTags.Site) + " / " + _toDisplayString(event.OriginTags.Aggregator), 1),
                _createElementVNode("td", null, _toDisplayString(event.Summary), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("span", {
                    title: event.Details
                  }, _toDisplayString(_ctx.truncate(event.Details, 50)), 9, _hoisted_14)
                ])
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}